import { Link } from "react-router-dom";
import { ShoppingBag, Gamepad2 } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const CurrencyToggle = () => {
  const { currency, setCurrency } = useStore();
  return (
    <div className="flex rounded-full bg-white/5 border border-white/10 p-1 text-xs font-mono" data-testid="currency-toggle">
      {["BRL", "EUR"].map((c) => (
        <button
          key={c}
          onClick={() => setCurrency(c)}
          data-testid={`currency-selector-${c.toLowerCase()}`}
          className={`px-3 py-1.5 rounded-full transition-colors ${currency === c ? "bg-violet-600 text-white" : "text-slate-400 hover:text-white"}`}
        >
          {c === "BRL" ? "R$" : "€"} {c}
        </button>
      ))}
    </div>
  );
};

export const StoreHeader = () => {
  const { settings, count, setCartOpen } = useStore();
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0B0F19]/80 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="store-header-logo">
          <span className="w-9 h-9 rounded-lg bg-violet-600 grid place-items-center group-hover:rotate-6 transition-transform">
            <Gamepad2 className="w-5 h-5 text-white" />
          </span>
          <span className="font-heading font-extrabold text-lg tracking-tight">{settings?.store_name || "Loja GugMC"}</span>
        </Link>
        <div className="flex items-center gap-3">
          <div className="hidden sm:block"><CurrencyToggle /></div>
          <button
            onClick={() => setCartOpen(true)}
            data-testid="cart-drawer-toggle-button"
            className="relative h-10 px-4 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors flex items-center gap-2 text-sm"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="hidden sm:inline">Carrinho</span>
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-5 h-5 px-1 rounded-full bg-emerald-500 text-[11px] font-bold grid place-items-center text-slate-950" data-testid="cart-count-badge">
                {count}
              </span>
            )}
          </button>
        </div>
      </div>
      <div className="sm:hidden px-5 pb-3"><CurrencyToggle /></div>
    </header>
  );
};
